module.exports = __webpack_public_path__ + "img/Temur Ketsbaia.51d2901d.png";